import { render, staticRenderFns } from "./indexVale.vue?vue&type=template&id=70392eeb"
import script from "./indexVale.vue?vue&type=script&lang=js"
export * from "./indexVale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports